import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './globals.css'

// Render app
const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<App />);

// Enable CSS transitions after initial render to prevent strobing
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.documentElement.classList.add('transitions-enabled');
  });
}); 